/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICusExternalGiftCard contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum showAdditionalFields {
    pin = 'pin',
    expirationDate = 'expirationDate',
    pinAndExpirationDate = 'pinAndExpirationDate'
}

export interface ICusExternalGiftCardConfig extends Msdyn365.IModuleConfig {
    showAdditionalFields?: showAdditionalFields;
    shouldBeEnabledForGuest?: boolean;
    className?: string;
    giftCardName?: string;
    tenderTypeId?: string;
    overrideCardBalanceForTesting?: boolean;
    allowOnlyOneGiftCardPerTransaction?: boolean;
    clientRender?: boolean;
}

export interface ICusExternalGiftCardResources {
    emptyInputError: string;
    invalidCodeError: string;
    invalidCardInfoError: string;
    invalidCardTypeError: string;
    noCardPinError: string;
    noCardExpError: string;
    duplicatedCodeError: string;
    noBalanceError: string;
    giftCardFormLabel: string;
    giftCardNumberLabel: string;
    giftCardPinLabel: string;
    giftCardExpLabel: string;
    giftCardPinPlaceholderText: string;
    giftCardExpPlaceholderText: string;
    giftCardAlertLabel: string;
    applyGiftCardButton: string;
    removeGiftCardButton: string;
    enteredGiftCardLabel: string;
    giftCardAvailableBalanceLabel: string;
    externalGiftCardAppliedLabel: string;
    externalGiftCardBalanceLabel: string;
    externalGiftCardTotalAppliedLabel: string;
}

export interface ICusExternalGiftCardProps<T> extends Msdyn365.IModule<T> {
    resources: ICusExternalGiftCardResources;
    config: ICusExternalGiftCardConfig;
}
